import React from 'react'
import PropTypes from 'prop-types'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  ButtonGroup,
  Input,
  Container,
  Label,
  Row,
  Col,
  CustomInput,
} from 'reactstrap'
import moment from '../../../lib/moment.js'
import get from 'lodash/get'
import find from 'lodash/find'
import findIndex from 'lodash/findIndex'
import reject from 'lodash/reject'
import shortid from 'shortid'
import styled from 'styled-components'
import DatePicker from 'react-datepicker'
import * as timesheetHelper from '../helpers/timesheet'
import SearchIcon from "../../../static/images/search_icon.svg"
import { FONTS } from '../../../constants'

export const CopyTimesheetForm = class extends React.Component {
  state={
    checkedTasks: [],
    selectedRadioCopy: 1,
    selectedDateCopy: moment(),
    tempSearch: '',
  }

  handleCheckBox = (e) => {
    const { myProjects, timesheets } = this.props
    const { selectedRadioCopy, selectedDateCopy, searchCopy } = this.state
    const filteredTimesheets = timesheetHelper.filterCopyTimesheet(
      selectedRadioCopy, selectedDateCopy, timesheets, myProjects, searchCopy)
    let { checkedTasks } = this.state
    const arr = (e.target.id).split('-')

    if (arr.length === 3) {
      const projectIndex = findIndex(filteredTimesheets, {
        project_id: arr[0],
        approver_id: arr[1],
        key: arr[2],
      })
      let isAllChecked = true
      for (let i = 0; i < filteredTimesheets[projectIndex].tasks.length; i++) {
        const task = filteredTimesheets[projectIndex].tasks[i]
        if (!checkedTasks.includes(`${e.target.id}-${i}-${task.task_name}`)) {
          isAllChecked = false
          break
        }
      }
      if (isAllChecked) {
        checkedTasks = reject(checkedTasks, (element) => { return element.includes(e.target.id) })
      } else {
        for (let i = 0; i < filteredTimesheets[projectIndex].tasks.length; i++) {
          const task = filteredTimesheets[projectIndex].tasks[i]
          if (!checkedTasks.includes(`${e.target.id}-${i}-${task.task_name}`)) {
            checkedTasks.push(`${e.target.id}-${i}-${task.task_name}`)
          }
        }
      }
    } else if (arr.length === 5) {
      const index = checkedTasks.indexOf(e.target.id)
      if (index > -1) {
        checkedTasks.splice(index, 1)
      } else {
        checkedTasks = [...this.state.checkedTasks, e.target.id]
      }
    }
    this.setState({ checkedTasks })
  }

  handleCopyTimesheet = (field, data) => {
    switch (field) {
      case 'date': {
        this.setState({
          selectedDateCopy: data,
          checkedTasks: [],
        })
        break
      }
      case 'radio': {
        this.setState({ selectedRadioCopy: data })
        break
      }
      case 'search': {
        this.setState({ searchCopy: this.state.tempSearch })
        break
      }
      default:
        break
    }
  }

  handleClickCopyButton = (type, filteredTimesheets) => {
    this.setState({
      checkedTasks: [],
      selectedRadioCopy: 1,
      selectedDateCopy: moment(),
      searchCopy: '',
      tempSearch: '',
    })
    switch (type) {
      case 'copy': {
        const myTimesheet = get(this.props, 'myTimesheet')
        const { checkedTasks } = this.state
        const newProjects = timesheetHelper.copyTimesheet(
          checkedTasks, filteredTimesheets, myTimesheet.timesheet, get(this.props, 'selectedDate'))
        let sumHoursByDate = get(this.props, 'sumHoursByDate')
        if (myTimesheet.timesheet.projects.length === 0) {
          sumHoursByDate = timesheetHelper.generateSumHoursByDate(get(this.props, 'dates'))
        }
        myTimesheet.timesheet.projects = newProjects
        this.props.clickCopyButton('copy', sumHoursByDate, myTimesheet)
        break
      }
      case 'cancel': {
        this.props.clickCopyButton('cancel')
        break
      }
      default:
        break
    }
  }

  render() {
    const { toggle } = this.props
    const { open, myProjects, timesheets } = this.props
    const { selectedRadioCopy, selectedDateCopy, searchCopy } = this.state
    const filteredTimesheets = timesheetHelper.filterCopyTimesheet(
      selectedRadioCopy, selectedDateCopy, timesheets, myProjects, searchCopy)
    return (
    /* eslint no-underscore-dangle: 0 */
      <div>
        <Modal
          isOpen={ open }
          toggle={ () => toggle() }
        >
          <ModalHeader toggle={ () => toggle() }>
            <HeadLabel>{ `Copy Timesheet` }</HeadLabel>
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col sm="12">
                <TypeButtonGroup>
                  <TypeButton
                    color="primary"
                    style={ {
                      backgroundColor: (selectedRadioCopy === 1) ? '#AD2624' : '#FFFFFF',
                      color: (selectedRadioCopy === 1) ? '#FFFFFF' : '#D44B49',
                      border: '1px solid #AD2624',
                    } }
                    onClick={ () => this.handleCopyTimesheet('radio', 1) }
                    active={ selectedRadioCopy === 1 }
                  >All
                  </TypeButton>
                  <TypeButton
                    color="primary"
                    style={ {
                      backgroundColor: (selectedRadioCopy === 2) ? '#AD2624' : '#FFFFFF',
                      color: (selectedRadioCopy === 2) ? '#FFFFFF' : '#D44B49',
                      border: '1px solid #AD2624',
                    } }
                    onClick={ () => this.handleCopyTimesheet('radio', 2) }
                    active={ selectedRadioCopy === 2 }
                  >Chargeable
                  </TypeButton>
                  <TypeButton
                    color="primary"
                    style={ {
                      backgroundColor: (selectedRadioCopy === 3) ? '#AD2624' : '#FFFFFF',
                      color: (selectedRadioCopy === 3) ? '#FFFFFF' : '#D44B49',
                      border: '1px solid #AD2624',
                    } }
                    onClick={ () => this.handleCopyTimesheet('radio', 3) }
                    active={ selectedRadioCopy === 3 }
                  >Non-Charge
                  </TypeButton>
                </TypeButtonGroup>
                <SearchWrapper>
                  <MonthContainer>
                    <CustomDatePicker
                      autoComplete='off'
                      onChange={ (e) => this.handleCopyTimesheet('date', e) }
                      placeholderText='DD/MM/YYYY'
                      selected={ selectedDateCopy }
                      dateFormat="DD/MM/YYYY"
                      showYearDropdown
                      showMonthDropdown
                    />
                  </MonthContainer>
                  <SearchField
                    placeholder='Search by project code or name'
                    onChange={ (e) => {
                      this.setState({ tempSearch: e.target.value })
                      if (e.target.value === '') this.setState({ searchCopy: '' })
                    }
                    }
                    onKeyDown={ (e) => {
                      if (e.keyCode === 13) this.handleCopyTimesheet('search', e)
                    }
                    }
                  />
                </SearchWrapper>
                <CheckboxGroup>
                  <Row>
                    <Col>
                      {
                        filteredTimesheets.map((project) => {
                          const proj = find(myProjects, { _id: project.project_id })
                          const approver = find(timesheets.users,
                            { _id: project.approver_id }) || {}
                          return (
                            <div key={ shortid() }>
                              <CustomInput
                                id={ `${get(project, 'project_id', '')}-${get(project, 'approver_id', '')}-${get(project, 'key', '')}` }
                                type='checkbox'
                                label={ `${get(proj, 'project_code', '')} - ${get(proj, 'name', '')} (${get(approver, 'first_name', '')} ${get(approver, 'last_name', '')} - ${get(approver, 'nick_name', '')})` }
                                onChange={ this.handleCheckBox }
                                checked={ this.state.checkedTasks.filter(
                                  element => element.includes(`${get(project, 'project_id', '')}-${get(project, 'approver_id', '')}-${get(project, 'key', '')}`)).length > 0
                                }
                              />
                              {
                                get(project, 'tasks', []).map((task, taskID) => {
                                  return (
                                    <div key={ shortid() } style={ { marginLeft: 20 } }>
                                      <CustomInput
                                        id={ `${get(project, 'project_id', '')}-${get(project, 'approver_id', '')}-${get(project, 'key', '')}-${taskID}-${get(task, 'task_name', '')}` }
                                        type='checkbox'
                                        label={ `${get(task, 'task_name', '')}` }
                                        onChange={ this.handleCheckBox }
                                        checked={ this.state.checkedTasks.includes(`${get(project, 'project_id', '')}-${get(project, 'approver_id', '')}-${get(project, 'key', '')}-${taskID}-${get(task, 'task_name', '')}`) }
                                      />
                                    </div>
                                  )
                                })
                              }
                              <br />
                            </div>
                          )
                        })
                      }
                    </Col>
                  </Row>
                </CheckboxGroup>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <FooterButton
              background='#AD2624'
              onClick={ () => this.handleClickCopyButton('copy', filteredTimesheets) }
              disabled={ this.state.checkedTasks.length === 0 }
            >Copy
            </FooterButton>
            <FooterButton
              background='white'
              color='black'
              onClick={ () => this.handleClickCopyButton('cancel') }
            >Cancel
            </FooterButton>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

CopyTimesheetForm.propTypes = {
  open: PropTypes.bool,
  myProjects: PropTypes.array,
  toggle: PropTypes.func,
  clickCopyButton: PropTypes.func,
  timesheets: PropTypes.object,
}
CopyTimesheetForm.defaultProps = {
  open: false,
  myProjects: [],
  toggle: () => {},
  clickCopyButton: () => {},
  timesheets: {},
}

const CustomDatePicker = styled(DatePicker)`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  max-width: 100px;
  height: 30px;
  padding-left: 5%;
  border-radius: 5px;
  border: ${props => {
    const status = props.selected
    if (status === '' || status === null) {
      return '1px solid #D9534F'
    }
    return '1px solid #CCCCCC'
  }};
`
const HeadLabel = styled(Label)`
  font-family: 'Gotham-Bold' !important;
  color: #AD2624;
`
const TypeButtonGroup = styled(ButtonGroup)`
  display: flex;
  font-family: 'Gotham' !important;
`
const TypeButton = styled(Button)`
  width: 100%;
`
const FooterButton = styled(Button)`
  margin-right: 10px;
  background-color: ${props => props.background};
  color: ${props => props.color};
  font-family: 'Gotham' !important;
  border: 1px solid #CCCCCC;
`
const SearchField = styled(Input)`
  width: 100%;
  padding-left: 35px;
  background: url(${SearchIcon}) no-repeat scroll 3%;
  background-size: 15px 15px;
  font-family: 'Gotham' !important;
  font-size: 15px;
  border: 1px solid #ccc;
  border-radius: 4px;
  -o-text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
  ::placeholder {
    color: #CCCCCC;
    font-size: 12px;
  }
`
const SearchWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
`
const CheckboxGroup = styled(Container)`
  height: 300px;
  overflow-y: scroll;
  margin-top: 20px;
  padding: 20px;
  border: 1px solid lightgray;
  border-radius: 5px;
  font-family: 'Gotham' !important;
  font-size: 15px;
`
const MonthContainer = styled.div`
  margin-right: 10px;
  input{
    max-width: 100px !important;
    max-height: 38px !important;
    min-height: 38px !important;
    font-size: 12px !important;
    border: 1px solid #ccc;
    border-radius: 4px;
  }
  .calendar-container {
    font-family: 'Gotham' !important;
    width: 200px !important;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 2;
    background: #fff;
    border: 2px solid #eee;
    border-bottom-right-radius: 5px;
    border-bottom-left-radius: 5px;
  }
  .col_mp:hover{
    background-color: #AD2624 !important;
  }
  .selected_date_mp{
    font-size:12px !important;
    color: #1A1A17 !important;
  }
  .selected_cell {
    font-family: 'Gotham-Bold' !important;
    background-color: #AD2624 !important;
  }
  .arrows_mp{
    font-weight: lighter !important;
    font-size: 12px !important;
  }

`



// WEBPACK FOOTER //
// ./src/components/timesheet/form/copy-timesheet.js